<template>
    <div>
        <div class="phoneBox">
            <el-form :model="ruleForm" :rules="rules"  label-width="100px" class="demo-ruleForm">
                <el-form-item  prop="phone">
                    <el-input  v-model="ruleForm.phone" placeholder="请输入手机号" maxlength="11" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input  v-model="ruleForm.password" placeholder="请输入密码" type="password" maxlength="20"></el-input>
                </el-form-item>
            </el-form>
            <div class="remember">
                <el-checkbox v-model="checked">记住密码</el-checkbox>
                <div @click="submitForm">登录</div>
            </div>
            <div class="forget" >
                <span @click="goBack">
                    忘记密码？
                </span>
            </div>
            <div class="registered">
                <p>还没有账号？</p>
                <span @click="goRegister">立即注册</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {passwordLogin} from "../../../api/login";

    export default {
        name: "password",
        props:['tab'],
        data(){
            return{
                phone:'',  //手机号
                cipher:'',  //密码
                checked:false, //记住密码
                ruleForm:{
                    phone:'', //账号
                    password:'', // 密码
                },
                rules: {
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'}
                    ],
                    password:[
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 6, max: 20, message: '密码最少为6位', trigger: 'blur'}
                    ],

                }
            }
        },
        mounted() {
            let username = sessionStorage.getItem("userId");
            if (username) {
                this.ruleForm.phone = sessionStorage.getItem("userId");
                this.ruleForm.password = Base64.decode(sessionStorage.getItem("password"));// base64解密
                this.checked = true;
            }
        },
        methods: {
            //登录
            submitForm(){
                if(this.ruleForm.phone==''||this.ruleForm.phone==null){
                    this.$message.error('手机号不能为空');
                }else if(this.ruleForm.password==''||this.ruleForm.password==null){
                    this.$message.error('密码不能为空');

                }else {
                    passwordLogin(this.ruleForm.phone,this.ruleForm.password).then(res=>{
                      if (res.code==200){
                          sessionStorage.setItem('token',res.data.token)
                          this.$router.push('/index')
                          this.$message.success("登录成功")
                      }else if(res.code==400){
                          this.$message.error(res.msg);
                      }

                    }).catch((err)=>{
                        console.log(err)
                    })
                }

            },
            keyDown (e) {
                if (this.tab==1){
                    if (e.keyCode === 13) {
                        this.submitForm()
                    }
                }
            },

        //    找回密码
            goBack(){
                this.$router.push('/forget')
            },
        //    立即注册
            goRegister(){
                this.$router.push('/registered')
            }
        },
        // 绑定监听事件
        mounted () {
            window.addEventListener('keydown', this.keyDown)
        },
        // 销毁事件
        destroyed () {
            window.removeEventListener('keydown', this.keyDown, false)
        },

    }
</script>

<style scoped>
    .remember{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .remember>div{
        cursor:pointer;
        width: 140px;
        height: 40px;
        background: #3d62f6;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        line-height: 40px;
    }
    .forget{
        cursor:pointer;
        color: #3d62f6;
        text-align: right;
        margin: 30px 0px;
    }
    .registered{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 45px;
        background-color: #fcfdfe;
        border: 0.5px solid #dde0eb;
        margin: 30px auto;
    }
    .registered>p{
        color: #8b8b8b;
    }
    .registered>span{
        color: #3d62f6;
        cursor:pointer;
    }
</style>
